"use client";

import Button from "@/components/ui/Button";

interface StepNavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
  canProceed: boolean;
  isLastStep: boolean;
  onSubmit?: () => void;
  isLoading?: boolean;
}

export default function StepNavigation({
  currentStep,
  totalSteps: _totalSteps,
  onNext,
  onPrevious,
  canProceed,
  isLastStep,
  onSubmit,
  isLoading = false,
}: StepNavigationProps) {
  return (
    <div className="flex items-center justify-between gap-4 mt-8 pt-6 border-t border-border">
      <Button
        type="button"
        variant="secondary"
        onClick={onPrevious}
        disabled={currentStep === 1 || isLoading}
        className="min-w-[100px]"
      >
        Previous
      </Button>

      <div className="flex-1" />

      {isLastStep ? (
        <Button
          type="button"
          onClick={onSubmit || (() => {})}
          disabled={!canProceed || isLoading || !onSubmit}
          isLoading={isLoading}
          className="min-w-[120px]"
          haptic="light"
        >
          Review & Submit
        </Button>
      ) : (
        <Button
          type="button"
          onClick={onNext}
          disabled={!canProceed || isLoading}
          className="min-w-[100px]"
          haptic="light"
        >
          Continue
        </Button>
      )}
    </div>
  );
}
